"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registry = void 0;
var lodash_1 = require("lodash");
var Types_1 = require("./Types");
var RouletteHttpAdapter_1 = require("./RouletteHttpAdapter");
var GamesHttpAdapter_1 = require("./GamesHttpAdapter");
var GamesStaticHttpAdapter_1 = require("./GamesStaticHttpAdapter");
var LotteryHttpAdapter_1 = require("./LotteryHttpAdapter");
var VSoccerHttpAdapter_1 = require("./VSoccerHttpAdapter");
var CrashCashHttpAdapter_1 = require("./CrashCashHttpAdapter");
var GamesHttpAdapterV2_1 = require("./GamesHttpAdapterV2");
var gamesHttpAdapters = [
    { name: Types_1.HttpAdapters.GamesHttpAdapter },
    { name: Types_1.HttpAdapters.GamesStaticHttpAdapter },
];
var gamesHttpAdaptersV2 = [
    { name: Types_1.HttpAdapters.GamesHttpAdapterV2 },
    { name: Types_1.HttpAdapters.GamesStaticHttpAdapter },
];
var lotteryHttpAdapters = [
    { name: Types_1.HttpAdapters.LotteryHttpAdapter },
    { name: Types_1.HttpAdapters.GamesStaticHttpAdapter },
];
var rouletteHttpAdapters = [
    { name: Types_1.HttpAdapters.RouletteHttpAdapter },
    { name: Types_1.HttpAdapters.GamesStaticHttpAdapter },
];
var vsoccerHttpAdapters = [
    { name: Types_1.HttpAdapters.VSoccerHttpAdapter },
    { name: Types_1.HttpAdapters.GamesStaticHttpAdapter },
];
var crashcashHttpAdapters = [
    { name: Types_1.HttpAdapters.CrashCashHttpAdapter },
    { name: Types_1.HttpAdapters.GamesStaticHttpAdapter },
];
exports.registry = {
    httpAdapters: {
        GamesHttpAdapter: GamesHttpAdapter_1.GamesHttpAdapter,
        GamesStaticHttpAdapter: GamesStaticHttpAdapter_1.GamesStaticHttpAdapter,
        LotteryHttpAdapter: LotteryHttpAdapter_1.LotteryHttpAdapter,
        RouletteHttpAdapter: RouletteHttpAdapter_1.RouletteHttpAdapter,
        VSoccerHttpAdapter: VSoccerHttpAdapter_1.VSoccerHttpAdapter,
        CrashCashHttpAdapter: CrashCashHttpAdapter_1.CrashCashHttpAdapter,
        GamesHttpAdapterV2: GamesHttpAdapterV2_1.GamesHttpAdapterV2,
    },
    messageProtocols: {
        postMessage: {
            name: 'postMessage',
        },
        gravityGateway: {
            name: 'gravityGateway',
        },
    },
    platforms: {
        playtech: {
            name: 'playtech',
        },
        seven: {
            name: 'seven',
        },
    },
    products: {
        greyhounds: {
            name: 'greyhounds',
            fqn: 'GreyhoundRaces',
            httpAdapters: gamesHttpAdapters,
            aliases: ['GreyhoundRaces', 'GR', 'greyhoundraces', 'greyhoundRaces'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        kolor: {
            name: 'kolor',
            fqn: 'VirtualKolor',
            httpAdapters: rouletteHttpAdapters,
            aliases: ['Kolor', 'NVNVKolor'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        lightningKolor: {
            name: 'lightningKolor',
            fqn: 'LightningKolor',
            httpAdapters: rouletteHttpAdapters,
            aliases: ['NVNVLightningKolor'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        lightningRoulette: {
            name: 'lightningRoulette',
            fqn: 'LightningRoulette',
            httpAdapters: rouletteHttpAdapters,
            aliases: ['NVNVLightningRoulette'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        lightningLuckysix: {
            name: 'lightningLuckysix',
            fqn: 'NVNVLightningLuckySix',
            httpAdapters: gamesHttpAdapters,
            aliases: ['NVNVLightningLuckySix'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        luckysix: {
            name: 'luckysix',
            fqn: 'LuckySix',
            httpAdapters: gamesHttpAdapters,
            aliases: ['LuckySix', 'LS', 'luckySix'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        luckyx: {
            name: 'luckyx',
            fqn: 'LuckyX',
            httpAdapters: gamesHttpAdapters,
            aliases: ['LuckyX', 'LX', 'luckyX'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        nextsix: {
            name: 'nextsix',
            fqn: 'NextSix',
            httpAdapters: gamesHttpAdapters,
            aliases: ['NextSix', 'NS', 'nextSix'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        numbersBetting: {
            name: 'numbersBetting',
            fqn: 'NumbersBetting',
            httpAdapters: lotteryHttpAdapters,
            aliases: ['NumbersBetting'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        roulette: {
            name: 'roulette',
            fqn: 'VirtualRoulette',
            httpAdapters: rouletteHttpAdapters,
            aliases: ['Roulette'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        slotCars: {
            name: 'slotCars',
            fqn: 'SlotCarRaces',
            httpAdapters: gamesHttpAdapters,
            aliases: ['SlotCarRaces', 'SCR', 'slotcarraces', 'slotCarRaces'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        vdr: {
            name: 'vdr',
            fqn: 'VirtualDragRaces',
            httpAdapters: gamesHttpAdaptersV2,
            aliases: ['VirtualDragRaces', 'VDR', 'virtualdragraces', 'virtualDragRaces'],
            gamesRegistryEndpoint: {
                production: 'https://games-vdr-registry.de-2.nsoft.cloud',
                staging: 'https://games-vdr-registry.staging.de-2.nsoft.cloud',
                // product id here is actually the subscription channel
                endpointPath: {
                    endpointPathTemplate: '/subscriptions/configurations/${subscriptionId}/${subscriptionChannel}',
                    replacements: [
                        {
                            replacementKey: 'subscriptionId',
                            replacementOptionsPath: 'productId',
                        },
                        {
                            replacementKey: 'subscriptionChannel',
                            replacementOptionsPath: 'channel',
                        },
                    ],
                },
                config: {
                    mappings: {
                        rules: [
                            {
                                name: 'maxBetNumber',
                                dataPath: 'maxBetCount',
                                defaultValue: 1,
                            },
                            {
                                name: 'maxBetAmount',
                                dataPath: 'maxBetAmount',
                                defaultValue: 100,
                            },
                            {
                                name: 'minBetAmount',
                                dataPath: 'minBetAmount',
                                defaultValue: 1,
                            },
                        ],
                        customProperties: [
                            {
                                name: 'status',
                                dataPath: 'status',
                            },
                        ]
                    },
                },
            },
        },
        vgr: {
            name: 'vgr',
            fqn: 'VirtualGreyhoundRaces',
            httpAdapters: gamesHttpAdapters,
            aliases: ['VirtualGreyhoundRaces', 'VGR', 'virtualgreyhoundraces', 'virtualGreyhoundRaces'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        vhr: {
            name: 'vhr',
            fqn: 'VirtualHorseRaces',
            httpAdapters: gamesHttpAdapters,
            aliases: ['VirtualHorseRaces', 'VHR', 'virtualhorseraces', 'virtualHorseRaces'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        vms: {
            name: 'vms',
            fqn: 'VirtualMotorcycleSpeedway',
            httpAdapters: gamesHttpAdapters,
            aliases: [
                'VirtualMotorcycleSpeedway',
                'VMS',
                'virutalmotorcyclespeedway',
                'virtualMotorcycleSpeedway',
            ],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        vps: {
            name: 'vps',
            fqn: 'VirtualPenaltyShootout',
            httpAdapters: gamesHttpAdapters,
            aliases: [
                'VirtualPenaltyShootout',
                'VPS',
                'virtualpenaltyshootout',
                'virtualPenaltyShootout',
            ],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        vsoccer: {
            name: 'vsoccer',
            fqn: 'VirtualSoccer',
            httpAdapters: vsoccerHttpAdapters,
            aliases: ['VirtualSoccer', 'VirtualSoccerDev', 'virtualsoccer', 'virtualSoccer'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        keno: {
            name: 'keno',
            fqn: 'Keno',
            httpAdapters: gamesHttpAdapters,
            aliases: ['Keno'],
            gamesRegistryEndpoint: {
                production: '',
                staging: '',
                endpointPath: {
                    endpointPathTemplate: '',
                    replacements: [],
                },
                config: {
                    mappings: {
                        rules: [],
                    },
                },
            },
        },
        crashcash: {
            name: 'crashcash',
            fqn: 'CrashCash',
            httpAdapters: crashcashHttpAdapters,
            aliases: ['CrashCash', 'CC', 'Crash', 'GamesTest'],
            gamesRegistryEndpoint: {
                production: 'https://games-crash-cash-registry.de-2.nsoft.cloud',
                staging: 'https://games-crash-cash-registry.staging.de-2.nsoft.cloud',
                endpointPath: {
                    endpointPathTemplate: '/configuration/subscriptions/${productId}/${channel}',
                    replacements: [
                        {
                            replacementKey: 'productId',
                            replacementOptionsPath: 'productId',
                        },
                        {
                            replacementKey: 'channel',
                            replacementOptionsPath: 'channel',
                        },
                    ],
                },
                config: {
                    mappings: {
                        rules: [
                            {
                                name: 'maxBetNumber',
                                dataPath: 'maxBetCount',
                                defaultValue: 1,
                            },
                            {
                                name: 'maxBetAmount',
                                dataPath: 'maxBetAmount',
                                defaultValue: 100,
                            },
                            {
                                name: 'minBetAmount',
                                dataPath: 'minBetAmount',
                                defaultValue: 1,
                            },
                            {
                                name: 'maxPossibleMultiplier',
                                dataPath: 'maxPossibleMultiplier',
                                defaultValue: 10000,
                            },
                        ],
                    },
                },
            },
        },
    },
    getProduct: function (productName) {
        var productByName = this.products[productName];
        if (productByName) {
            return productByName;
        }
        var productByAlias = (0, lodash_1.find)(this.products, function (product) {
            if (product.aliases && product.aliases.indexOf(productName) > -1) {
                return product;
            }
        });
        return productByAlias;
    },
    translationDomainsMapping: {
        // TC/nsoft-i18n domain name and its Frasier ID equivalent
        'betting-greyhound-races': '4b42804c75510b3f74d2fc54d5e4effe',
        'Betting.GreyhoundRaces': '4b42804c75510b3f74d2fc54d5e4effe',
        'betting-keno': '6e97d48c5bc965124b963f94132aaed3',
        'Betting.Keno': '6e97d48c5bc965124b963f94132aaed3',
        'games-crash-cash-visualization': 'b176b147191b8581f70a422978da2dfa',
        GamesCrashCashVisualization: 'b176b147191b8581f70a422978da2dfa',
        'games-racers-visualization': '5d3f6dd9d354ed7269a6fe05723a560a',
        GamesRacersVisualization: '5d3f6dd9d354ed7269a6fe05723a560a',
        'games-vdr-visualization': '02d6407cd3080df03debd4ca39e555b6',
        'Games.VDR.Visualization': '02d6407cd3080df03debd4ca39e555b6',
        'games-vps-betting': '2a45fc255f1771e31ca8344dd98018fe',
        'Games.VPS.Betting': '2a45fc255f1771e31ca8344dd98018fe',
        'games-vps-visualization': 'ea778ca51796e032ce1f1c698976bb9a',
        'Games.VPS.Visualization': 'ea778ca51796e032ce1f1c698976bb9a',
        lottery: 'c3385d374ae3fbf44f517a972b8d011f',
        Lottery: 'c3385d374ae3fbf44f517a972b8d011f',
        'nb-lottery-register': 'cc160c96397123bd211b03e7bc92902c',
        'nb.lotteryregister': 'cc160c96397123bd211b03e7bc92902c',
        'vgr-visualization': 'f0db284db1997200971cf6c023783506',
        'VGR.Visualization': 'f0db284db1997200971cf6c023783506',
        'vhr-visualization': '44426a4d494b57a927853e64c209d727',
        'VHR.Visualization': '44426a4d494b57a927853e64c209d727',
        visuals: '9b4e04738493129a956e5da219fb3eda',
        Visuals: '9b4e04738493129a956e5da219fb3eda',
        'visuals-keno': '493cfe2cb3204c6573a695179e37d6c0',
        'Visuals.Keno': '493cfe2cb3204c6573a695179e37d6c0',
        'visuals-greyhound-races-v3': '0a824fd16578f8a05e04621dd206eddc',
        'Visuals.GreyhoundRacesV3': '0a824fd16578f8a05e04621dd206eddc',
        'visuals-greyhound-races-v4': 'a600b445923312c9bd610b0193716261',
        'Visuals.GreyhoundRacesV4': 'a600b445923312c9bd610b0193716261',
        'visuals-greyhound-races-v5': '4d1152edccb43df18e7cebf7032b9c24',
        'Visuals.GreyhoundRacesV5': '4d1152edccb43df18e7cebf7032b9c24',
        'visuals-lucky-six-v5': '8edf9e3ac92ee1b6da3a58a129ce2d72',
        'Visuals.LuckySixV5': '8edf9e3ac92ee1b6da3a58a129ce2d72',
        'visuals-lucky-six-v5-pi': 'b3c9d72753b6dfe35c1646c21d1ba178',
        'Visuals.LuckySixV5Pi': 'b3c9d72753b6dfe35c1646c21d1ba178',
        'visuals-lucky-six-v6': '05e4cfc0a2a89e737f8b393e13bc1a5c',
        'Visuals.LuckySixV6': '05e4cfc0a2a89e737f8b393e13bc1a5c',
        'visuals-lucky-x': '6c4f9f8af87f8ef4aa6b2b0de4a3f3e4',
        'Visuals.LuckyX': '6c4f9f8af87f8ef4aa6b2b0de4a3f3e4',
        'visuals-multi-product-jackpot': '8112ce8b1a3747a6783831c5bc858484',
        'Visuals.MultiProductJackpot': '8112ce8b1a3747a6783831c5bc858484',
        'visuals-nextsix': 'f963d3e5f926cacf1c963dfc5136f937',
        'Visuals.NextSix': 'f963d3e5f926cacf1c963dfc5136f937',
        'visuals-slot-car-races': '24a6918a001803a96e8a0b45ab54d143',
        'Visuals.SlotCarRaces': '24a6918a001803a96e8a0b45ab54d143',
        'visuals-world-number-service': 'd302f0d97362dfc599cf6d1ae2b1a623',
        'Visuals.WorldNumberService': 'd302f0d97362dfc599cf6d1ae2b1a623',
        'vms-visualization': '9147de4424c019364bbccb2b6c563806',
        'VMS.Visualization': '9147de4424c019364bbccb2b6c563806',
        vsoccer: '25c596b216fd1ecb70d6de03e6f57bb0',
        VSoccer: '25c596b216fd1ecb70d6de03e6f57bb0',
    },
};
//# sourceMappingURL=Registry.js.map